export default "__VITE_ASSET__MJEG52dg__"